import entryFactory from 'bpmn-js-properties-panel/lib/factory/EntryFactory'

import cmdHelper from 'bpmn-js-properties-panel/lib/helper/CmdHelper'

export default function(element, bpmnFactory, options, translate) {
  let iteratorCollection = entryFactory.textField({
    id: 'iteratorCollection',
    label: 'Collection Name',
    modelProperty: 'iteratorCollection',

    set: function(element, values, node) {
      let bo = element.businessObject
      let prop = {}
      prop['iteratorCollection'] = values.iteratorCollection
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      var iteratorCollectionVar = bo.get('iteratorCollection')
      return {
        iteratorCollection: iteratorCollectionVar,
        label: 'Please provide the Collection name that has to be Iterated'
      }
    },
    validate: function(element, values, node) {
      return !values.iteratorCollection
        ? { iteratorCollection: 'Must provide a value' }
        : {}
    }
  })

  return [iteratorCollection]
}
